"use strict";

function __export(m) {
  for (var p in m) {
    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

__export(require("./Paragraph"));

var ParagraphWithMargin_1 = require("./ParagraphWithMargin");

exports.ParagraphWithMargin = ParagraphWithMargin_1.default;